import { CotationFormData } from "@/types/forms/home/cotationFormData.form";
import { CotationsPageComponent } from "./component/CotationsPageComponent";
import { useGetPreference } from "@/api/preference.api";
import { useCreateQuotation } from "@/api/expedition.api";
import { useGetCustomsV1 } from "@/api/customs.api";

const CotationsPage = () => {
  const { mutateAsync: createQuotation, isPending: isCreatingQuotation } = useCreateQuotation();
  const { data: customs, isPending: fetchingCustoms } = useGetCustomsV1();
  const { data: preference, isPending: fetchingPreference } = useGetPreference();

  const onSubmit = async (data: CotationFormData) => {
    const cotationWoodBox = data.woodBoxesActivated
      ? data.woodBoxes.map((woodBox) => ({
          bottleQuantity: woodBox.bottleQuantity,
          boxQuantity: woodBox.boxQuantity,
          bottleVolume: woodBox.bottleVolume,
        }))
      : [];

    const deliveryFromDate =
      data.deliveryDateRadio === "earliestDelivery"
        ? null
        : data.deliveryDateRadio === "customDelivery"
          ? data.customDeliveryDate
            ? data.customDeliveryDate.toISOString()
            : null
          : null;

    await createQuotation({
      customId: data.country,
      dapOption: data.dapOption,
      express: data.express,
      insurance: data.insurance,
      otherFees: data.otherFees || 0,
      cotationProducts: data.products.map((product) => ({
        volume: product.volume,
        bottleQuantity: product.bottleQuantity,
        value: product.value,
      })),
      cotationWoodBox,
      lastName: data.customer.lastName || undefined,
      firstName: data.customer.firstName || undefined,
      company: data.customer.companyName || undefined,
      deliveryFromDate: deliveryFromDate,
    });
  };

  if (fetchingCustoms || fetchingPreference) return <div>Chargement...</div>;
  if (!customs || !preference) return <div>Erreur lors du chargement des préférences</div>;

  return (
    <CotationsPageComponent
      handleSubmit={onSubmit}
      preference={preference}
      isPending={isCreatingQuotation}
      customs={customs}
    />
  );
};

export default CotationsPage;
